import {mapMutations, mapGetters} from "vuex";

export default {
    name: "password-email",
    data() {
        return {
            isRegister: false
        }
    },
    methods: {
        ...mapMutations({
            changeShowPopUpLogin: 'auth/CHANGE_POPUP_LOGIN',
            changeShowPopUpRegister: 'auth/CHANGE_POPUP_REGISTER'
        }),
        loginUser() {
            this.changeShowPopUpRegister(false)
            this.changeShowPopUpLogin(true)

        }
    },
    computed: {
        ...mapGetters({
            showPopUpLogin: `auth/showPopUpLogin`
        }),
    }
}

